import styled from "styled-components";

export const Container = styled.div(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Primary,
    margin: `10px ${theme.spacing.medium} ${theme.spacing.medium}`,
    borderRadius: theme.cornerRadius.medium,
    boxShadow: "0 1px 16px rgba(0,0,0,.05)",
}));

export const TitleContainer = styled.div(({ theme }) => ({
    margin: `${theme.spacing.medium} 0 0 0`,
    display: "flex",
}));

export const NewTagWrapper = styled.div(({ theme }) => ({
    margin: `0 0 ${theme.spacing.medium} calc(${theme.spacing.small} * -1)`,
    transform: "translate(0, 1px)",
}));

export const ToastContainer = styled.div(({ theme }) => ({
    "& .toast": {
        bottom: theme.spacing.xLarge,
        left: theme.spacing.medium,
        right: theme.spacing.medium,
        zIndex: 9,
    },
}));
